module.exports = __webpack_public_path__ + "static/hairun-logo-2461d8799fe518365ea5de4ae305e951.svg";